import useGet from "src/hooks/useGet";
import useHooks from "src/hooks/useHooks";


export function useGetUsers(id?: string) {
    const { get, query } = useHooks();
    const response = useGet({
        name: "UserList",
        url: `/all/webusers`,
        params: {
            page: Number(get(query, "page", 1)),
            limit: Number(get(query, "limit", 10)),

        },
    });
    return response;
}